var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 202,
    viewBox: "0 0 282 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.916 21.409C238.917 21.409 232.916 21.409 228.916 21.409L225.916 2.40873C231.415 2.40873 234.417 2.40797 240.416 2.40873L242.916 21.409ZM261.21 33.1993C261.916 21.408 256.416 20.6987 246.784 21.408L244.916 2.40868C264.415 1.72807 279.916 3.19949 278.917 37.1989L261.21 33.1993ZM261.21 50.6995C261.4 46.9209 261.212 41.6992 261.21 38.1992L278.917 42.1992C278.917 48.1218 278.917 50.1995 278.917 55.6995L261.21 50.6995Z",
    fill: "url(#paint0_linear_17_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.604 21.409C220.604 21.409 213.484 21.409 209.484 21.409L206.483 2.40873C211.981 2.40873 215.416 2.40797 221.416 2.40873L224.604 21.409Z",
    fill: "url(#paint1_linear_17_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8731 25H36.5827C34.3033 25 32.1321 25.9723 30.6143 27.6728L14.0316 46.2515C12.7232 47.7174 12 49.6137 12 51.5786V121.255V190H207.121H233.416C235.696 190 237.868 189.027 239.386 187.326L255.969 168.739C257.277 167.273 258 165.377 258 163.413V93.7453V25H62.8731Z",
    fill: "#D50032",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267 127V163.836C267 168.786 265.252 173.576 262.063 177.363L249.293 192.527C245.303 197.265 239.425 200 233.23 200H205",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 73L2 52.7792C2 47.8923 3.70438 43.1583 6.81951 39.393L20.7011 22.6137C24.6906 17.7915 30.623 15 36.8816 15L74 15",
    stroke: "black",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_5",
    x1: 166.5,
    y1: -26.5,
    x2: 282,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50032",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D50032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_5",
    x1: 166.5,
    y1: -26.5,
    x2: 282,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50032",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D50032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRating);
export default __webpack_public_path__ + "static/media/high-rating.e94fba7ea2cc052922527cc8d162ab62.svg";
export { ForwardRef as ReactComponent };